import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './BottomFloat.css';

interface IBottomFloatProps {
  isVisible: boolean;
}

export const BottomFloat = ({ children, isVisible }: React.PropsWithChildren<IBottomFloatProps>): React.JSX.Element => {
  return <div className={clsx(styles['bottom'], isVisible && styles['visible'])}>{children}</div>;
};
